import Vue from "vue";
import moment from "moment";
import config from "../../config/config"
Vue.mixin({
    methods: {
        moment: function(date) {
            if (date)
                return moment(date);
            else
                return moment();
        },
        MessageBox(title, text, type,dismiss = true) {
            this.$confirm(text, title, {
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก',
                showCancelButton: dismiss,
                type: type
            }).then(() => {}).catch(() => {});
        },
        formatDate(date) {
            return moment(date).format("DD/MM/YYYY")
        },
        config() {
            return config
        },
        isNumberKey: function(evt) {
            var charCode = (evt.which) ? evt.which : evt.keyCode
            if ((charCode >= 48  && charCode <= 57) || (charCode == 8) || (charCode == 37) || (charCode == 39)){
              evt.returnValue = true;
            } else {
              evt.returnValue = false;
            }
        },
        isDecimalKey: function(evt) {
            var charCode = (evt.which) ? evt.which : evt.keyCode
            if ((charCode >= 48  && charCode <= 57) || (charCode == 8) || (charCode == 37) || (charCode == 39) || (charCode == 46)){
              evt.returnValue = true;
            } else {
              evt.returnValue = false;
            }
        },
        checkCharater: function(evt) {
            var charCode = (evt.which) ? evt.which : evt.keyCode
            if ((charCode >= 32  && charCode <= 126) || (charCode == 8)){
              evt.returnValue = true;
            } else {
              evt.returnValue = false;
            }
        },
        alphaNumuric: function(evt){
            var charCode = (evt.which) ? evt.which : evt.keyCode
            var not_allowed = [58,59,60,61,62,63,64,91,92,93,94,95,96]
            if ((charCode >= 48  && charCode <= 122) && !(not_allowed.includes(charCode)) ){
              evt.returnValue = true;
            } else {
              evt.returnValue = false;
            }
        }
    }
})